export const themeBasePath = 'assets/nitro/';

/**
 * Responsive breakpoints shared across UI Bricks styled components. Each entry documents whether it
 * is meant as a `max-width` or a `min-width` bound. Use these instead of hardcoding pixel values or
 * importing `BreakPoint` from `@makemydeal/dr-activities-common` so the thresholds stay consistent.
 */
export const BreakPoints = {
    /** Mobile / phone devices (`max-width`, <= 768px) */
    PHONE: '767px',
    /** Tablet devices (`max-width`, <= 1280px) */
    TABLET: '1279px',
    /**
     * Desktop threshold, used as a `min-width` bound (>= 992px).
     *
     * TODO: needs to be revisited -- this duplicates `BreakPoint.MEDIUM` ('992px') from
     * `@makemydeal/dr-activities-common`, which dash uses to size its customer-card slideout
     * (`EditCustomerSlideout`). The two breakpoint sources should collapse into one once the
     * customer card's slideout chrome is shared between MV and SCI.
     */
    DESKTOP: '992px' // Not to be used throughout the sales-checkin application.
};
